import React, { useEffect, useState } from "react";
import "../Portfolio.css";
import Card from "../Card";
import { Link } from "react-router-dom";
import ArrowForwardIcon from "@material-ui/icons/ArrowForward";

function Portfolio() {
    useEffect(() => {
      document.title = "My portfolio";
    }, []);
    
    const scrollToTop = () => {
        window.scrollTo(0, 1);
    }

    useEffect(() => {
      scrollToTop();
    });

  return (
    <div className="pf">
      <div className="background">
        <img src={process.env.PUBLIC_URL + '/images/home/slika.jpg'} />
      </div>
      <h1 className="header">My Portfolio</h1>
      <div className="container">
        <div className="animate__animated animate__zoomIn">
          <div className="row">
            <div className="col-md-3">
              <Card
                cardClass="card netflix-card"
                cardTitle="Netflix clone"
                cardDescription="Front-end Netflix clone made using React.js and a few others web
              technologies."
                cardLink="https://github.com/danielbradaric/neflix-clone"
                cardUrl={process.env.PUBLIC_URL + '/images/portfolio/slika.png'}
                buttonText="Learn more"
              />
            </div>
            <div className="col-md-3">
              <Card
                cardClass="card"
                cardTitle="Spotify clone"
                cardDescription="Spotify front-end clone made using Spotify API, React.js, Contex API and more."
                cardLink="https://github.com/danielbradaric/spotify-clone"
                cardUrl={process.env.PUBLIC_URL + '/images/portfolio/slika1.png'}
                buttonText="Learn more"
              />
            </div>
            <div className="col-md-3">
              <Card
                cardClass="card"
                cardTitle="Slack clone"
                cardDescription="Functional Slack clone made using React.js, Context API, Google API and Firestore."
                cardLink="https://github.com/danielbradaric/slack-clone"
                cardUrl={process.env.PUBLIC_URL + '/images/portfolio/slika2.png'}
                buttonText="Learn more"
              />
            </div>
            <div className="col-md-3">
              <Card
                cardClass="card"
                cardTitle="Tik-Tok clone"
                cardDescription="Fully mobile responsive Tik-Tok clone made using React.js and Firestore database."
                cardLink="https://github.com/danielbradaric/TikTok-clone"
                cardUrl={process.env.PUBLIC_URL + '/images/portfolio/slika3.png'}
                buttonText="Learn more"
              />
            </div>
          </div>
        </div>
      </div>
      <div className="button-container">
        <Link to="/about-me" className="about-link">
          About Me <ArrowForwardIcon />
        </Link>
      </div>
    </div>
  );
}

export default Portfolio;
